import React from "react";
import TabletShowcase from "./TabletShowcase"; // Adjust path as needed

const Hero = () => {
	return (
		<section className="relative min-h-screen bg-black overflow-hidden flex items-center">
			{/* Animated Background Gradients */}
			<div className="absolute inset-0">
				<div className="absolute top-1/4 right-1/4 w-96 h-96 bg-gradient-to-br from-orange-700/20 to-orange-500/20 rounded-full blur-3xl animate-pulse"></div>
				<div className="absolute bottom-1/4 left-1/4 w-80 h-80 bg-gradient-to-tr from-orange-600/15 to-orange-400/15 rounded-full blur-3xl animate-pulse delay-1000"></div>
				<div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-gradient-to-r from-orange-800/10 to-orange-600/10 rounded-full blur-3xl"></div>
			</div>

			{/* Content */}
			<div className="relative z-10 w-full px-4 sm:px-6 py-12 sm:py-16 md:py-20">
				<div className="max-w-7xl mx-auto">
					{/* Grid Layout for Content + Tablet */}
					<div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-16 items-center">
						{/* Left Side - Text Content */}
						<div className="max-w-4xl">
							<h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl font-bold text-white mb-8 md:mb-12 leading-tight">
								Digital products that{" "}
								<span className="bg-gradient-to-r from-orange-700 to-orange-500 bg-clip-text text-transparent">
									matter
								</span>
								, powered by{" "}
								<span className="bg-gradient-to-r from-orange-700 to-orange-500 bg-clip-text text-transparent">
									technical passion
								</span>{" "}
								and endless{" "}
								<span className="bg-gradient-to-r from-orange-700 to-orange-500 bg-clip-text text-transparent">
									curiosity
								</span>
							</h1>

							<p className="text-lg md:text-xl text-gray-300 mb-8 md:mb-12 max-w-2xl leading-relaxed">
								Building innovative web experiences and digital solutions with
								modern technologies and creative vision.
							</p>

							{/* CTA Button */}
							<div className="flex items-center space-x-4 mb-4 lg:mb-0">
								<a
									href="/projects"
									className="inline-flex items-center px-6 md:px-8 py-3 md:py-4 bg-gradient-to-r from-orange-700 to-orange-500 text-white rounded-full hover:from-orange-800 hover:to-orange-600 transition-all duration-200 font-medium text-base md:text-lg group"
								>
									<span>Explore James' work</span>
									<svg
										className="w-4 h-4 md:w-5 md:h-5 ml-2 group-hover:translate-x-1 transition-transform duration-200"
										fill="none"
										stroke="currentColor"
										viewBox="0 0 24 24"
									>
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth={2}
											d="M17 8l4 4m0 0l-4 4m4-4H3"
										/>
									</svg>
								</a>
							</div>
						</div>

						{/* Right Side - Tablet Animation */}
						<div className="flex justify-center items-center min-h-[200px] lg:min-h-[500px] -mt-12 lg:mt-0">
							<div className="scale-50 sm:scale-75 lg:scale-100">
								<TabletShowcase />
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Hero;
